import React, { useEffect, useState, useRef } from "react";
import { Link, Outlet } from "react-router-dom";
import Backdrop from "../../../asserts/CRMbg.png";
import {
  GetBarChartDetails,
  GetDashboardDetails,
} from "../../../Api/Dashboard/Dashboard";
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  Spin,
  Tooltip,
  Popover,
  ConfigProvider,
  DatePicker,
  QRCode,
} from "antd";
import "../../../App.css";
import { IoMdTrendingUp, IoMdTrendingDown } from "react-icons/io";
import {
  TbReceiptRupee,
  TbReceiptTax,
  TbRosetteDiscount,
} from "react-icons/tb";
import { FaPeopleGroup } from "react-icons/fa6";
import { decryptData } from "../../Common/Encrypt-Decrypt";
import dashMan from "../../../asserts/dashboardMan.gif";
import arrowGif from "../../../asserts/arrowGif.gif";
import flagPole from "../../../asserts/flagPole.png";
import ticket from "../../../asserts/ticket.png";
import greenTick from "../../../asserts/greenTick.png";
import redCross from "../../../asserts/redCross.png";
import blueRev from "../../../asserts/blueRev.png";
import dashes1 from "../../../asserts/dashes1.png";
import dashes2 from "../../../asserts/dashes2.png";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip as ReTooltip,
  Line,
  ComposedChart,
  Scatter,
  LineChart,
  ScatterChart,
  ZAxis,
} from "recharts";
import { PieChart, Pie, Sector, Cell } from "recharts";
import { GetPayDashDetails } from "../../../Api/Payments/Payments";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { Formik, Field, Form, ErrorMessage } from "formik";
import dayjs from "dayjs";
import moment from "moment";
import fareIcon from "../../../asserts/fareIcon.png";
import gstIcon from "../../../asserts/gstIcon.png";
import offerIcon from "../../../asserts/gstIcon.png";
import spent from "../../../asserts/spent.png";
import balance from "../../../asserts/balance.png";
import spent1 from "../../../asserts/spent.svg";
import { GetPatDashboardDetails } from "../../../Api/Dashboard/PartnerDashboard";
import appLogo from "../../../asserts/appLogo.svg";

export const PartnerDashTable = ({
  setTable,
  deviceid,
  activePicker,
  setActivePicker,
  swap,
  setSwap,
  dates,
  isView,
}) => {
  const playStoreUrl =
    "https://play.google.com/store/apps/details?id=com.thebusstandapp&ref=";
  const [spinning, setSpinning] = useState(false);
  //   const [table, setTable] = useState("dashboard");
  // const [activePicker, setActivePicker] = useState("Weekly");
  // const [swap, setSwap] = useState("amount");
  const [hovered, setHovered] = useState(null);
  const [hideTool, setHideTool] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  console.log(hoveredIndex, "indexindex");

  const dispatch = useDispatch();
  const getDashboardDetails =
    useSelector((state) => state.crm.dashboard_details) || [];
  const getPatDashboardDetails =
    useSelector((state) => state.crm.pat_dashboard_details) || [];
  console.log(getPatDashboardDetails, "DASHBOARD details dashboard");
  console.log(deviceid, "deviceidid");
  console.log(dates, "datesdates");
  const access_id = Number(sessionStorage.getItem("accessId"));
  console.log(access_id, typeof access_id, "accessidididididid");

  const refCode = sessionStorage.getItem("refferal_code");
  console.log(refCode,"refcode")
  useEffect(() => {
    setSpinning(true);
    GetPatDashboardDetails(dispatch, setSpinning, refCode);
  }, []);

  
  console.log(deviceid, swap, dates, "checkcheckcheck");
  const abhiBalance =
    useSelector((state) => state.crm.available_balance) || "0";

  const formatNumber = (value) => {
    if (value === undefined || value === null || isNaN(value)) {
      return "Invalid value";
    }
    if (value >= 1000000) {
      return Math.floor((value / 1000000) * 10) / 10 + "m"; // Millions
    } else if (value >= 1000) {
      return Math.floor((value / 1000) * 10) / 10 + "k"; // Thousands
    } else {
      return value.toString(); // Small numbers as is
    }
  };

  const [activeIndexes] = useState([0, 1, 2]);
  const onChange = (date, dateString) => {
    console.log(date, dateString);
  }
  const CustomTooltip = ({ active, payload, label }) => {
    console.log(active, payload, label, "toolProps");
    if (!active || !payload || payload.length === 0) return null;

    // Filter out duplicate dataKeys, keeping only the first occurrence
    const seen = new Set();
    const filteredPayload = payload.filter((entry) => {
      if (seen.has(entry.dataKey)) return false;
      seen.add(entry.dataKey);
      return true;
    });
    console.log(filteredPayload, "filtereddd");

    if (active && payload && payload.length) {
      return (
        <div className="bg-white text-[1vw] p-[0.5vw] rounded-[0.5vw] border-[0.1vw] border-[#1f4b7f]">
          {!barChartDetails[0].date && dates ? (
            <p className="font-semibold mb-1">
              {containsAlphabets(label) ? label : formatDate2(label)}
            </p>
          ) : (
            <p className="font-semibold mb-1">{label}</p>
          )}
          <div className="flex gap-[0.25vw]">
            <div>
              <div className="bg-[#02CA70] rounded-full w-[0.75vw] h-[0.75vw] mt-[0.35vw]"></div>
              <div className="bg-[#FF574B] rounded-full w-[0.75vw] h-[0.75vw] mt-[0.7vw]"></div>
            </div>
            <div>
              {filteredPayload.map((entry, index) => (
                <p key={index} className="">
                  <span>{entry.name}:</span>
                  {/* ₹ {entry.value} */}
                  <span className="font-bold">
                    {swap === "amount"
                      ? ` ₹ ${entry.value.toLocaleString()}`
                      : `${entry.value}`}
                  </span>
                </p>
              ))}
            </div>
          </div>
          <div className="flex items-center ">
            {filteredPayload.map((entry, index) => (
              <p key={index} className="flex items-center gap-[0.25vw]">
                {index === 1 ? (
                  <>
                    <div className="bg-[#3E7DFB] rounded-full w-[0.75vw] h-[0.75vw]"></div>
                    <span>Refunded:</span>
                    <span className="font-bold">
                      {swap === "amount"
                        ? `₹ ${entry.value.toLocaleString()}`
                        : `${entry.value}`}
                    </span>
                  </>
                ) : (
                  ""
                )}
              </p>
            ))}
          </div>

          {/* <p className="text-gray-500 mt-2 italic">Anything you want can be displayed here.</p> */}
        </div>
      );
    }

    return null;
  };

  const NeedleTooltip = ({ active, payload }) => {
    if (!active || !payload || payload.length === 0) return null;
    console.log(payload[0], "paypaypay");
    return (
      <div className="bg-white text-[1vw] p-[0.5vw] rounded-[0.5vw] border-[0.1vw] border-[#1f4b7f] ">
        <p>
          {payload[0].name}:{" "}
          <span className="font-bold">
            ₹{payload[0].value.toLocaleString("en-IN")}
          </span>
        </p>
      </div>
    );
  };

  const AmtNo1 = Number(
    // decryptData
    getDashboardDetails?.piechart?.totalFare
  );
  const AmtNo2 = Number(
    // decryptData
    getDashboardDetails?.piechart?.cancellationRefund
  );
  const AmtNo3 = Number(
    // decryptData
    getDashboardDetails?.piechart?.cancellationRefund
  );
  // (getDashboardDetails?.refundedAmount));
  console.log(AmtNo1, AmtNo2, AmtNo3, "amtamtamt");
  const dataPieAmount = [
    {
      name: "Booked",
      color: "#02CA70",
      value: (AmtNo1 / (AmtNo1 + AmtNo2 + AmtNo3)) * 100,
      amount: AmtNo1,
    },
    {
      name: "Cancelled",
      color: "#FF574B",
      value: (AmtNo2 / (AmtNo1 + AmtNo2 + AmtNo3)) * 100,
      amount: AmtNo2,
    },
    {
      name: "Refunded",
      color: "#3E7DFB",
      value: (AmtNo3 / (AmtNo1 + AmtNo2 + AmtNo3)) * 100,
      amount: AmtNo3,
    },
  ];
  console.log(dataPieAmount[0], "datadata");
  const CntNo1 = Number(
    // decryptData
    getDashboardDetails?.piechart?.bookingCount
  );
  const CntNo2 = Number(
    // decryptData
    getDashboardDetails?.piechart?.cancellationCount
  );
  const CntNo3 = Number(
    // decryptData
    getDashboardDetails?.piechart?.cancellationCount
  );
  // (getDashboardDetails?.piechart?.refundedCount));
  const bookedCntValue = parseFloat(
    ((CntNo1 / (CntNo1 + CntNo2 + CntNo3)) * 100).toFixed(2)
  );
  const cancelledCntValue = parseFloat(
    ((CntNo2 / (CntNo1 + CntNo2 + CntNo3)) * 100).toFixed(2)
  );
  const refundedCntValue = parseFloat(
    ((CntNo3 / (CntNo1 + CntNo2 + CntNo3)) * 100).toFixed(2)
  );
  function adjustPercentages(values) {
    let roundedValues = values.map((v) => Math.round(v)); // Round each value
    let difference = 100 - roundedValues.reduce((sum, v) => sum + v, 0); // Compute the difference

    // Adjust the largest value to make the sum exactly 100%
    let maxIndex = roundedValues.indexOf(Math.max(...roundedValues));
    roundedValues[maxIndex] += difference;

    return roundedValues;
  }

  const dataPieCount = [
    {
      name: "Booked",
      color: "#02CA70",
      value: bookedCntValue,
      count:
        // decryptData
        getDashboardDetails?.piechart?.bookingCount,
    },
    {
      name: "Cancelled",
      color: "#FF574B",
      value: cancelledCntValue,
      count:
        // decryptData
        getDashboardDetails?.piechart?.cancellationCount,
    },
    {
      name: "Refunded",
      color: "#3E7DFB",
      value: refundedCntValue,
      count:
        // decryptData
        getDashboardDetails?.piechart?.cancellationCount,
    },
  ];

  const cntTotal = dataPieCount.reduce((sum, item) => sum + item.count, 0);

  // Calculate percentages and round to two decimal places
  let updatedDataPieCount = dataPieCount.map((item) => ({
    ...item,
    value: parseFloat(((item.count / cntTotal) * 100).toFixed(2)), // Ensures consistent decimal rounding
  }));

  const passengerXValue = getDashboardDetails?.piechart?.passenger_x;
  const passengerYValue = getDashboardDetails?.piechart?.passenger_y;
  const passengerXPct = parseFloat(
    ((passengerXValue / (passengerXValue + passengerYValue)) * 100).toFixed(2)
  );
  const passengerYPct = parseFloat(
    ((passengerYValue / (passengerXValue + passengerYValue)) * 100).toFixed(2)
  );

  const DataPiePassengers = [
    {
      name: "PassengerX",
      color: "#02CA70",
      value: passengerXPct,
      count:
        // decryptData
        passengerXValue,
    },
    {
      name: "PassengerY",
      color: "#FF574B",
      value: passengerYPct,
      count:
        // decryptData
        passengerYValue,
    },
  ];

  // Fix rounding errors
  const totalCntPercentage = updatedDataPieCount.reduce(
    (sum, item) => sum + item.value,
    0
  );
  const cntDifference = 100 - totalCntPercentage;

  if (cntDifference !== 0) {
    // Find the item with the highest value and adjust it
    let maxItem = updatedDataPieCount.reduce((prev, curr) =>
      prev.value > curr.value ? prev : curr
    );
    maxItem.value = parseFloat((maxItem.value + cntDifference).toFixed(2));
    console.log(updatedDataPieCount, maxItem, totalCntPercentage, "updated");
  }

  const AmtTotal = dataPieAmount.reduce((sum, item) => sum + item.amount, 0);

  // Calculate percentages and round to two decimal places
  let updatedDataPieAmount = dataPieAmount.map((item) => ({
    ...item,
    value: parseFloat(((item.amount / AmtTotal) * 100).toFixed(2)), // Ensures consistent decimal rounding
  }));

  // Fix rounding errors
  const totalAmtPercentage = updatedDataPieAmount.reduce(
    (sum, item) => sum + item.value,
    0
  );
  const amtDifference = 100 - totalAmtPercentage;

  if (amtDifference !== 0) {
    // Find the item with the highest value and adjust it
    let maxItem = updatedDataPieAmount.reduce((prev, curr) =>
      prev.value > curr.value ? prev : curr
    );
    maxItem.value = parseFloat((maxItem.value + amtDifference).toFixed(2));
    console.log(
      updatedDataPieAmount,
      maxItem,
      totalAmtPercentage,
      (AmtNo1 / (AmtNo1 + AmtNo2 + AmtNo3)) * 100,
      (AmtNo2 / (AmtNo1 + AmtNo2 + AmtNo3)) * 100,
      (AmtNo3 / (AmtNo1 + AmtNo2 + AmtNo3)) * 100,
      "updated2"
    );
  }

  const per = ((CntNo1 / (CntNo1 + CntNo2 + CntNo3)) * 100).toFixed(2);
  console.log(bookedCntValue, cancelledCntValue, refundedCntValue, "perperper");
  const PieTooltip1 = (props) => {
    const { active, payload } = props;
    if (active && payload && payload.length) {
      const tooltipData = payload[0]?.payload; // Fetch data correctly
      const { name, amount, color } = tooltipData || {};
      console.log(tooltipData, "ttoottototot");

      return (
        <div className="bg-white text-[1vw] p-[0.5vw] rounded-[0.5vw] border-[0.1vw] border-[#1f4b7f] flex items-center gap-[0.2vw]">
          <div
            className={`bg-[${color}] rounded-full w-[0.5vw] h-[0.5vw]`}
          ></div>
          <p className="">
            {name}:<span className="font-bold">₹{amount.toFixed(2)}</span>
          </p>
        </div>
      );
    }
    return null;
  };
  const PieTooltip2 = (props) => {
    const { active, payload } = props;
    if (active && payload && payload.length) {
      const tooltipData = payload[0]?.payload; // Fetch data correctly
      const { name, count, color } = tooltipData || {};

      return (
        <div className="bg-white text-[1vw] p-[0.5vw] rounded-[0.5vw] border-[0.1vw] border-[#1f4b7f] flex items-center gap-[0.2vw]">
          <div
            className={`bg-[${color}] rounded-full w-[0.5vw] h-[0.5vw]`}
          ></div>
          <p className="">
            {name}: <span className="font-bold">{count}</span>
          </p>
        </div>
      );
    }
    return null;
  };
  const COLORS = ["#02CA70", "#FF574B", "#3E7DFB"];

  //

  const renderActiveShape = (props) => {
    const {
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill,
      payload,
      percent,
      value,
    } = props;
    console.log(payload, "paypaypay");
    const RADIAN = Math.PI / 180;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? "start" : "end";
    const offset = 10;
    const labelX = cx + (outerRadius + offset) * cos; // Horizontal position based on angle
    const labelY = cy + (outerRadius + offset) * sin - 2; // Vertical position, moved 30px above

    const radius = outerRadius + 10;
    const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
    const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));

    return (
      <g>
        <text x={cx} y={cy} textAnchor="middle">
          <tspan
            x={cx}
            dy="-7.5"
            fontSize="0.85vw"
            fontWeight="lighter"
            fill="#737373"
          >
            {swap === "amount"
              ? "Passengers"
              : swap === "count" && "Passengers"}
          </tspan>
          <tspan
            x={cx}
            dy="35"
            fontWeight="bold"
            fontSize="1.75vw"
            fill="black"
          >
            {swap === "amount"
              ? formatNumber(
                  getDashboardDetails?.piechart?.totalFare +
                    getDashboardDetails?.piechart?.cancellationRefund +
                    getDashboardDetails?.piechart?.cancellationRefund
                )
              : swap === "count" &&
                getDashboardDetails?.piechart?.bookingCount +
                  getDashboardDetails?.piechart?.cancellationCount +
                  getDashboardDetails?.piechart?.cancellationCount}
            {/* {hoveredIndex === "PassengerX" ? `${getDashboardDetails?.piechart?.passenger_x}` : hoveredIndex === "PassengerY" ? `${getDashboardDetails?.piechart?.passenger_y}` : `${getDashboardDetails?.piechart?.passenger_x + getDashboardDetails?.piechart?.passenger_y}`} */}
          </tspan>
        </text>

        {/* Active Pie Sector */}
        <Sector
          cx={cx}
          cy={cy}
          // innerRadius={innerRadius}
          // outerRadius={outerRadius + 6}
          innerRadius={
            hoveredIndex === payload.name ? innerRadius + 16 : innerRadius + 8
          }
          outerRadius={
            hoveredIndex === payload.name ? outerRadius + 25 : outerRadius + 8
          }
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
          isAnimationActive={true} // Enables built-in animation
          className={`transition-all duration-500 ease-in-out`}
        />
        {/* Circle above the slice */}
        <circle
          cx={labelX}
          // cx={hoveredIndex === payload.name ? labelX + 12 : labelX }
          cy={labelY}
          // cy={hoveredIndex === payload.name ? labelY + 12 : labelY }
          r="1.5vw"
          fill="white"
          stroke={fill}
          strokeWidth={2}
        />
        {/* <rect
          x={x - 20} // Adjust horizontal positioning
          y={y - 10} // Adjust vertical positioning
          width="40" // Wider than height to get the tablet look
          height="15"
          rx="10" // Rounded corners to create the tablet effect
          ry="10"
          fill="white"
          stroke={fill}
          strokeWidth={2}
        /> */}

        {/* Value inside the circle */}
        <text
          // x={labelX}
          x={hoveredIndex === payload.name ? labelX + 12 : labelX}
          // y={labelY}
          y={hoveredIndex === payload.name ? labelY + 12 : labelY}
          // x={x - 2.5} // Adjust horizontal positioning
          // y={y - 2.5} // Adjust vertical positioning
          textAnchor="middle"
          dominantBaseline="central"
          className="fill-gray-800 font-semibold text-[0.8vw]"
        >
          {value}%
        </text>
      </g>
    );
  };

  const RADIAN = Math.PI / 180;

  // const needle = (percentage, cx, cy, iR, oR, color) => {
  //   const offset = 4.5
  //   const ang = 180 - (percentage * 180) / 100 - offset; // Corrected calculation
  //   const length = (iR + 2 * oR) / 3;
  // const sin = Math.sin(-RADIAN * ang);
  // const cos = Math.cos(-RADIAN * ang);
  // const r = 5;
  // const x0 = cx; // Match Pie cx
  // const y0 = cy; // Match Pie cy
  // const xba = x0 + r * sin;
  // const yba = y0 - r * cos;
  // const xbb = x0 - r * sin;
  // const ybb = y0 + r * cos;
  // const xp = x0 + length * cos;
  // const yp = y0 + length * sin;

  // return [
  //   <circle cx={x0} cy={y0} r={r} fill={color} stroke="none" />,
  //   <path d={`M${xba} ${yba} L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`} stroke="none" fill={color} />,
  // ];

  // };

  const getNeedleSize = () => {
    return Math.max(3, window.innerWidth * 0.005); // Adjust size based on screen width
  };
  const [needleSize, setNeedleSize] = useState(getNeedleSize());

  useEffect(() => {
    const handleResize = () => {
      setNeedleSize(getNeedleSize());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const needle = (percentage, cx, cy, iR, oR, color) => {
    const offset = 0;
    const ang = 180 - (percentage * 180) / 100 + offset;

    const r = needleSize; // Now it's dynamic!
    // const length = (iR + 2 * oR) / 4 * (window.innerWidth / 1000);
    const length = ((iR + 2 * oR) / 3.5) * (window.innerWidth / 1200);

    const sin = Math.sin(-RADIAN * ang);
    const cos = Math.cos(-RADIAN * ang);

    const x0 = cx,
      y0 = cy;
    const xba = x0 + r * sin,
      yba = y0 - r * cos;
    const xbb = x0 - r * sin,
      ybb = y0 + r * cos;
    const xp = x0 + length * cos,
      yp = y0 + length * sin;

    return [
      <circle cx={x0} cy={y0} r={r} fill={color} stroke="none" />,
      <path
        d={`M${xba} ${yba} L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`}
        stroke="none"
        fill={color}
      />,
    ];
  };

  const needleValue = parseFloat(
    (abhiBalance || "0").toString().replace(/,/g, "")
  );
  console.log(needleValue, "balancebalance");

  const leftValue = Number((200000 - needleValue).toFixed(2));
  const rightValue = Number(needleValue.toFixed(2));
  const percentage = Math.round((leftValue / 200000) * 100); // Convert 0-200000 scale to 0-100
  const needlaChartdata = [
    { name: "Booked", value: leftValue, color: "#ff574b" },
    { name: "Balance", value: rightValue, color: "#02ca70" },
  ];

  const handleAmtBarChartFilter = (value) => {
    console.log(value, "activeactive");
    if (value === "Weekly") {
      // GetDashboardDetails(dispatch,setSpinning,1,"null","null",1,1)
      if (deviceid === 0) {
        GetDashboardDetails(
          dispatch,
          setSpinning,
          0,
          "null",
          "null",
          1,
          1,
          access_id
        );
      } else if (deviceid === 1) {
        GetDashboardDetails(dispatch, setSpinning, 1, "null", "null", 1, 1);
      } else if (deviceid === 2) {
        GetDashboardDetails(dispatch, setSpinning, 2, "null", "null", 1, 1);
      } else {
        GetDashboardDetails(
          dispatch,
          setSpinning,
          0,
          "null",
          "null",
          1,
          1,
          access_id
        );
      }
    } else if (value === "Monthly") {
      // GetDashboardDetails(dispatch,setSpinning,1,"null","null",2,1)
      if (deviceid === 0) {
        GetDashboardDetails(dispatch, setSpinning, 0, "null", "null", 2, 1);
      } else if (deviceid === 1) {
        GetDashboardDetails(dispatch, setSpinning, 1, "null", "null", 2, 1);
      } else if (deviceid === 2) {
        GetDashboardDetails(dispatch, setSpinning, 2, "null", "null", 2, 1);
      } else {
        GetDashboardDetails(dispatch, setSpinning, 0, "null", "null", 2, 1);
      }
    } else if (value === "Yearly") {
      // GetDashboardDetails(dispatch,setSpinning,1,"null","null",3,1)
      if (deviceid === 0) {
        GetDashboardDetails(dispatch, setSpinning, 0, "null", "null", 3, 1);
      } else if (deviceid === 1) {
        GetDashboardDetails(dispatch, setSpinning, 1, "null", "null", 3, 1);
      } else if (deviceid === 2) {
        GetDashboardDetails(dispatch, setSpinning, 2, "null", "null", 3, 1);
      } else {
        GetDashboardDetails(dispatch, setSpinning, 0, "null", "null", 3, 1);
      }
    }
  };

  const handleCntBarChartFilter = (value) => {
    console.log(value, "activeactive");
    if (value === "Weekly") {
      // GetDashboardDetails(dispatch,setSpinning,1,"null","null",1,2)
      if (deviceid === 0) {
        GetDashboardDetails(dispatch, setSpinning, 0, "null", "null", 1, 2);
      } else if (deviceid === 1) {
        GetDashboardDetails(dispatch, setSpinning, 1, "null", "null", 1, 2);
      } else if (deviceid === 2) {
        GetDashboardDetails(dispatch, setSpinning, 2, "null", "null", 1, 2);
      } else {
        GetDashboardDetails(dispatch, setSpinning, 0, "null", "null", 1, 2);
      }
    } else if (value === "Monthly") {
      // GetDashboardDetails(dispatch,setSpinning,1,"null","null",2,2)
      if (deviceid === 0) {
        GetDashboardDetails(dispatch, setSpinning, 0, "null", "null", 2, 2);
      } else if (deviceid === 1) {
        GetDashboardDetails(dispatch, setSpinning, 1, "null", "null", 2, 2);
      } else if (deviceid === 2) {
        GetDashboardDetails(dispatch, setSpinning, 2, "null", "null", 2, 2);
      } else {
        GetDashboardDetails(dispatch, setSpinning, 0, "null", "null", 2, 2);
      }
    } else if (value === "Yearly") {
      // GetDashboardDetails(dispatch,setSpinning,1,"null","null",3,2)
      if (deviceid === 0) {
        GetDashboardDetails(dispatch, setSpinning, 0, "null", "null", 3, 2);
      } else if (deviceid === 1) {
        GetDashboardDetails(dispatch, setSpinning, 1, "null", "null", 3, 2);
      } else if (deviceid === 2) {
        GetDashboardDetails(dispatch, setSpinning, 2, "null", "null", 3, 2);
      } else {
        GetDashboardDetails(dispatch, setSpinning, 0, "null", "null", 3, 2);
      }
    }
  };
  // const barChartDetails =
  //   useSelector((state) => state.crm.barchart_details) || [];
  const barChartDetails = getDashboardDetails.barchart || [];
  console.log(barChartDetails, "detaildetails");

  const baseFare = Number(
    // decryptData
    getDashboardDetails?.piechart?.baseFare
  ).toFixed(2);
  const tbsDeal = Number(
    // decryptData
    getDashboardDetails?.piechart?.tbsDealAmount
  ).toFixed(2);
  const tbsFare = baseFare - tbsDeal;

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      console.log(entries);
    });

    observer.observe(document.body);

    return () => observer.disconnect(); // Cleanup on unmount
  }, []);

  const ncx = (8.05 / 100) * window.innerWidth;
  const ncy = (12.45 / 100) * window.innerWidth;
  const chartWidth = document.querySelector("recharts-wrapper");
  const chartHeight = document.querySelector("recharts-wrapper");
  const needleWidth = chartWidth * 0.05; // Adjust the factor as needed
  const needleHeight = chartHeight * 10;

  const { RangePicker } = DatePicker;

  const handleAmount = async (values) => {
    setSwap("amount");
    if (isView === "All") {
      await GetDashboardDetails(
        dispatch,
        setSpinning,
        0,
        moment(values[0].$d).format("YYYY-MM-DD"),
        moment(values[1].$d).format("YYYY-MM-DD"),
        1,
        1
      );
    } else if (isView === "Desktop") {
      await GetDashboardDetails(
        dispatch,
        setSpinning,
        1,
        moment(values[0].$d).format("YYYY-MM-DD"),
        moment(values[1].$d).format("YYYY-MM-DD"),
        1,
        1
      );
    } else if (isView === "Mobile") {
      await GetDashboardDetails(
        dispatch,
        setSpinning,
        2,
        moment(values[0].$d).format("YYYY-MM-DD"),
        moment(values[1].$d).format("YYYY-MM-DD"),
        1,
        1
      );
    }
  };

  const handleCount = async (values) => {
    setSwap("count");
    if (isView === "All") {
      await GetDashboardDetails(
        dispatch,
        setSpinning,
        0,
        moment(values[0].$d).format("YYYY-MM-DD"),
        moment(values[1].$d).format("YYYY-MM-DD"),
        1,
        2
      );
    } else if (isView === "Desktop") {
      await GetDashboardDetails(
        dispatch,
        setSpinning,
        1,
        moment(values[0].$d).format("YYYY-MM-DD"),
        moment(values[1].$d).format("YYYY-MM-DD"),
        1,
        2
      );
    } else if (isView === "Mobile") {
      await GetDashboardDetails(
        dispatch,
        setSpinning,
        2,
        moment(values[0].$d).format("YYYY-MM-DD"),
        moment(values[1].$d).format("YYYY-MM-DD"),
        1,
        2
      );
    }
  };
  const containsAlphabets = (str) => /[a-zA-Z]/.test(str);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    // const options = { day: "2-digit", month: "short", year: "numeric" };
    const options = { day: "2-digit", month: "short" };
    return date.toLocaleDateString("en-GB", options);
  };

  const formatDate2 = (dateStr) => {
    const date = new Date(dateStr);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options);
    return formattedDate.replace(/(\d{2} \w{3})/, "$1,");
  };

  return (
    <div>
      <div className="w-full h-[78.5vh] rounded-[1vw] bg-[#fff] mt-[0.01vw] border-[#1f4b7f] border-t-[0.1vw] border-l-[0.1vw] border-r-[0.2vw] border-b-[0.2vw] p-[2vw]">
        {/* bg-[#1f4a7f34] */}
        {spinning ? (
          <div className="absolute top-[50vh] left-[50vw] flex justify-center items-center  z-10 col-span-6">
            <Spin size="large" />
          </div>
        ) : (
          <div className="grid grid-cols-4 h-full">
            <div className="col-span-3 grid grid-rows-3 gap-[2vw] pr-[2vw]">
              <div className="row-span-1 grid grid-cols-6 gap-[2vw] text-white">
                <div className="col-span-3 bg-[#1DA461] rounded-[0.75vw] dash-container2">
                  <p className="text-[2vw] h-[60%] flex justify-center items-center font-bold">
                    {getPatDashboardDetails?.total_earnings
                      ? `₹ ${getPatDashboardDetails?.total_earnings}`
                      : "-"}
                  </p>
                  <p className="text-[1.2vw] h-[40%] bg-[#1a8b53] rounded-b-[0.75vw] flex justify-center items-center">
                    Total Earnings
                  </p>
                </div>
                <div className="col-span-3 bg-[#DD5144] rounded-[0.75vw] dash-container2">
                  <p className="text-[2vw] h-[60%] flex justify-center items-center font-bold">
                    -
                  </p>
                  <p className="text-[1.2vw] h-[40%] bg-[#d13e31] rounded-b-[0.75vw] flex justify-center items-center">
                    Pending Payouts
                  </p>
                </div>
              </div>
              <div className="row-span-1 grid grid-cols-6 gap-[2vw] text-white">
                <div className="col-span-2 bg-[#1e5cad] rounded-[0.75vw] dash-container2">
                  <p className="text-[2vw] h-[60%] flex justify-center items-center font-bold">
                    {getPatDashboardDetails?.total_installs
                      ? getPatDashboardDetails?.total_installs
                      : "-"}
                  </p>
                  <p className="text-[1.2vw] h-[40%] bg-[#1F487C] rounded-b-[0.75vw] flex justify-center items-center">
                    Total Installs
                  </p>
                </div>
                <div className="col-span-2 bg-[#1e5cad] rounded-[0.75vw] dash-container2">
                  <p className="text-[2vw] h-[60%] flex justify-center items-center font-bold">
                    {getPatDashboardDetails?.first_bookings
                      ? getPatDashboardDetails?.first_bookings
                      : "-"}
                  </p>
                  <p className="text-[1.2vw] h-[40%] bg-[#1F487C] rounded-b-[0.75vw] flex justify-center items-center">
                    No. of First Bookings
                  </p>
                </div>
                <div className="col-span-2 bg-[#1e5cad] rounded-[0.75vw] dash-container2">
                  <p className="text-[2vw] h-[60%] flex justify-center items-center font-bold">
                    {getPatDashboardDetails?.booking_rates
                      ? `${Math.floor(getPatDashboardDetails?.booking_rates)} %`
                      : "-"}
                  </p>
                  <p className="text-[1.2vw] h-[40%] bg-[#1F487C] rounded-b-[0.75vw] flex justify-center items-center">
                    Booking Efficiency
                  </p>
                </div>
              </div>
            </div>
            <div className="col-span-1 border-zinc-500 border-l-[0.2vw] flex justify-center items-center">
              <div className="border-[0.1vw] border-[#969ba1] rounded-[0.25vw]">
                <div className="flex justify-center p-[0.5vw]">
                  <QRCode
                    errorLevel="H"
                    // size={160}
                    style={{width:"10vw",height:"10vw"}}
                    bordered={false}
                    value={
                      refCode ? `${playStoreUrl}${refCode}` : `${playStoreUrl}`
                    }
                    icon={appLogo}
                  />
                </div>
                <p className="text-[1.2vw] bg-[#1F487C] text-white text-center font-semibold">
                  {refCode ? refCode : "-"}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
